import React from 'react';
import {
  Box,
  Container,
  Stack,
  Text,
  Link,
  useColorModeValue,
  IconButton,
  HStack,
} from '@chakra-ui/react';
import { FaTwitter, FaLinkedin, FaGithub, FaInstagram, FaYoutube } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const MotionBox = motion(Box);

const SocialButton = ({ icon, label, href }) => {
  return (
    <MotionBox
      as="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      cursor="pointer"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      rounded="full"
      w={8}
      h={8}
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}
      transition="background 0.3s ease"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <IconButton
        aria-label={label}
        icon={icon}
        size="sm"
        variant="ghost"
        color={useColorModeValue('gray.600', 'gray.300')}
        _hover={{ bg: 'transparent' }}
      />
    </MotionBox>
  );
};

const FooterLink = ({ children, to }) => (
  <Link
    as={RouterLink}
    to={to}
    fontSize="sm"
    color={useColorModeValue('gray.600', 'gray.400')}
    _hover={{
      color: useColorModeValue('blue.500', 'blue.300'),
      textDecoration: 'none',
    }}
    transition="color 0.3s ease"
  >
    {children}
  </Link>
);

export default function Footer() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box
      as="footer"
      bg={bgColor}
      color={textColor}
      borderTopWidth={1}
      borderStyle={'solid'}
      borderColor={borderColor}
    >
      <Container
        as={Stack}
        maxW={'6xl'}
        py={6}
        spacing={4}
        justify={'center'}
        align={'center'}
      >
        <Text
          fontSize="xl"
          fontWeight="bold"
          color={useColorModeValue('blue.600', 'blue.300')}
        >
          Quodara Chrono
        </Text>
        <HStack spacing={6} wrap="wrap" justify="center">
          <FooterLink to={'/privacy-policy'}>Datenschutz</FooterLink>
          <FooterLink to={'/imprint'}>Impressum</FooterLink>
        </HStack>
        <Stack direction={'row'} spacing={6}>
          <SocialButton icon={<FaTwitter />} label={'Twitter'} href={'https://twitter.com/ForgeIdeas'} />
          <SocialButton icon={<FaLinkedin />} label={'LinkedIn'} href={'https://www.linkedin.com/company/forgeideas/'} />
          <SocialButton icon={<FaGithub />} label={'GitHub'} href={'https://github.com/storminator89/Zeiterfassung'} />
          <SocialButton icon={<FaInstagram />} label={'Instagram'} href={'https://www.instagram.com/forgeideas.de/'} />
          <SocialButton icon={<FaYoutube />} label={'YouTube'} href={'https://www.youtube.com/@forgeideas-ai'} />
        </Stack>
      </Container>

      <Box
        borderTopWidth={1}
        borderStyle={'solid'}
        borderColor={borderColor}
      >
        <Container
          as={Stack}
          maxW={'6xl'}
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ base: 'center', md: 'space-between' }}
          align={{ base: 'center', md: 'center' }}
        >
          <Text fontSize={'sm'}>
            © 2024 Quodara Chrono. Alle Rechte vorbehalten.
          </Text>
          <Text fontSize={'sm'}>
            Made with ❤️ in Deutschland
          </Text>
        </Container>
      </Box>
    </Box>
  );
}
